import React from "react";

import LegalLayout from "../LegalLayout";

function PolitiqueConfidentialite() {
  return (
    <LegalLayout title="Politique de confidentialité">
          <h2 className="fs-4 mt-4">1. Responsable du traitement</h2>
          <p>
            L’organisme de formation <strong> SAS Autoformation</strong>, dont le siège est situé 
            <strong>182 RUE LAVOISIER, 57600 OETING France</strong>, est responsable du traitement des données personnelles collectées.
          </p>
          <p>
            Pour toute question relative à la protection de vos données, vous pouvez nous contacter à : 
            <strong> contact@auto-formations.fr</strong>.
          </p>

          <h2 className="fs-4 mt-4">2. Données collectées</h2>
          <ul>
            <li>Identité : nom, prénom, date de naissance</li>
            <li>Coordonnées : adresse postale, téléphone, email</li>
            <li>Informations professionnelles : fonction, employeur, situation professionnelle</li>
            <li>Données liées à la formation : inscriptions, présence, résultats, attestations</li>
          </ul>

          <h2 className="fs-4 mt-4">3. Finalités du traitement</h2>
          <p>Les données collectées sont utilisées uniquement pour :</p>
          <ul>
            <li>l’inscription et la gestion administrative des formations,</li>
            <li>le suivi pédagogique et l’évaluation des acquis,</li>
            <li>l’édition des conventions, contrats, attestations et factures,</li>
            <li>la gestion de la relation client et du financement des formations (OPCO, CPF, etc.),</li>
            <li>le respect des obligations légales liées à la formation professionnelle.</li>
          </ul>

          <h2 className="fs-4 mt-4">4. Base légale du traitement</h2>
          <ul>
            <li>l’exécution d’un contrat ou d’une convention de formation,</li>
            <li>le respect d’obligations légales (Code du travail, obligations comptables),</li>
            <li>l’intérêt légitime de l’Organisme (suivi qualité, amélioration des services).</li>
          </ul>

          <h2 className="fs-4 mt-4">5. Destinataires des données</h2>
          <p>
            Les données peuvent être transmises, dans la limite de leurs attributions :
          </p>
          <ul>
            <li>aux services internes de l’Organisme,</li>
            <li>aux financeurs de la formation (OPCO, CPF, Pôle emploi, etc.),</li>
            <li>aux autorités administratives compétentes (DREETS, organismes de certification, etc.),</li>
            <li>aux prestataires techniques intervenant dans la réalisation de la formation (plateformes e-learning, outils de visioconférence).</li>
          </ul>

          <h2 className="fs-4 mt-4">6. Durée de conservation</h2>
          <p>
            Les données personnelles sont conservées pendant une durée maximale de <strong>10 ans</strong> après la fin de la relation contractuelle, 
            sauf obligation légale particulière imposant une durée plus longue.
          </p>

          <h2 className="fs-4 mt-4">7. Droits des personnes concernées</h2>
          <p>
            Conformément au RGPD et à la loi Informatique et Libertés, vous disposez des droits suivants :
          </p>
          <ul>
            <li>droit d’accès, de rectification et de suppression,</li>
            <li>droit à la limitation et à l’opposition au traitement,</li>
            <li>droit à la portabilité de vos données,</li>
            <li>droit d’introduire une réclamation auprès de la CNIL (www.cnil.fr).</li>
          </ul>
          <p>
            Pour exercer vos droits, vous pouvez contacter : <strong>contact@auto-formations.fr</strong>.
          </p>

          <h2 className="fs-4 mt-4">8. Sécurité des données</h2>
          <p>
            L’Organisme met en place des mesures techniques et organisationnelles appropriées 
            pour protéger vos données contre la perte, l’accès non autorisé, la divulgation ou la modification.
          </p>

          <h2 className="fs-4 mt-4">9. Modification de la politique</h2>
          <p>
            La présente politique de confidentialité peut être mise à jour en fonction de l’évolution de la réglementation 
            ou des pratiques de l’Organisme. La version en vigueur est disponible sur simple demande.
          </p>
    </LegalLayout>
    
  );
}

export default PolitiqueConfidentialite;